/**
 * Loading placeholder matching PropertyCard's silhouette, so property grids
 * reserve their layout while `/api/properties` resolves.
 */
import Skeleton from '@/components/ui/Skeleton';

export default function PropertyCardSkeleton() {
  return (
    <div
      data-testid="property-card-skeleton"
      aria-hidden="true"
      className="overflow-hidden rounded-2xl border border-line bg-surface shadow-sm"
    >
      {/* twMerge in Skeleton's cn() lets rounded-none override its default */}
      <Skeleton className="aspect-[4/3] w-full rounded-none" />
      <div className="space-y-3 p-5">
        <Skeleton height="1.25rem" width="75%" />
        <Skeleton height="0.875rem" width="50%" />
        <Skeleton height="0.875rem" width="66%" />
      </div>
    </div>
  );
}
